import { render, staticRenderFns } from "./filtroPedidos.vue?vue&type=template&id=06dbed14&"
import script from "./filtroPedidos.vue?vue&type=script&lang=js&"
export * from "./filtroPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports